export const logout = async () => {
  try {
    // await axios.post("users/signout");
    localStorage.clear();
  } catch (error) {}
};
